import { ActionCreatorWithPayload, createAction, Dispatch } from '@reduxjs/toolkit';
import * as Actions from './types';
import { MessageDetailsInterface } from '../interfaces/chatMessageInterface';
import { rootStore } from '../mobx/rootStore';

/**
 * @desc Set Project loader
 */
export const setProjectLoader: ActionCreatorWithPayload<boolean, string> = createAction(Actions.SET_PROJECT_LOADER);

/**
 * @desc Set discussion Data
 */
export const setDiscussionData: ActionCreatorWithPayload<MessageDetailsInterface[], string> = createAction(
  Actions.SET_DISCUSSION_DATA
);

/**
 * @desc Clear project Data
 */
export const clearProjectData = () => (dispatch: Dispatch) => {
  dispatch(setProjectLoader(false));
  dispatch(setDiscussionData([]));
  rootStore.projectStore.setUploadFilePercent(0);
  rootStore.projectStore.setProjects([]);
  rootStore.projectStore.setProjectUserNotIn([]);
  rootStore.projectStore.createProjectInput?.clear();
};
